/** Kannada: how the agent bargains, the owner's usual pace. */
export const bargain = {
    "bargain.label": "ನಿಮ್ಮ ಏಜೆಂಟ್ ಸಾಮಾನ್ಯವಾಗಿ ಹೇಗೆ ಚೌಕಾಸಿ ಮಾಡಬೇಕು",
    "bargain.what": "ನಿಮ್ಮ ಏಜೆಂಟ್ ಪ್ರತಿ ಕೆಲಸದಲ್ಲೂ ಸ್ವಲ್ಪ ಬೇರೆ ಬೆಲೆಯಿಂದ ಶುರುಮಾಡಿ ಬೇರೆ ರೀತಿಯಲ್ಲಿ ಇಳಿಯುತ್ತದೆ, ಹೀಗಾಗಿ ಯಾರಿಗೂ ನಿಮ್ಮ ಮಿತಿ ಊಹಿಸಲು ಆಗುವುದಿಲ್ಲ. ಇದು ಅದರ ಸಾಮಾನ್ಯ ವೇಗ; ಅದು ನಿಮ್ಮ ಮಿತಿಯನ್ನು ಎಂದೂ ದಾಟುವುದಿಲ್ಲ.",
    "bargain.patient": "ತಾಳ್ಮೆಯಿಂದ",
    "bargain.steady": "ಸಮತೋಲನದಿಂದ",
    "bargain.quick": "ಬೇಗ",
};
//# sourceMappingURL=bargain.js.map